class DropdownItem extends HTMLElement {
    constructor() {
      super();
  
      this.header = this.querySelector(".dropdown-header");
      this.description = this.querySelector(".dropdown-description");
      this.isOpen = this.hasAttribute("open"); 
  
      if (this.isOpen) {
        this.description.style.height = `${this.description.scrollHeight}px`;
      } else {
        this.description.style.height = "0";
      }
    }
  
    connectedCallback() {
      this.header.addEventListener("click", () => this.toggleDescription());
    }
  
    toggleDescription() {
      this.isOpen = !this.isOpen;
  
      if (this.isOpen) {
        this.description.style.height = `${this.description.scrollHeight}px`;
        this.setAttribute("open", "");
      } else {
        this.description.style.height = "0";
        this.removeAttribute("open");
      }
    }
  }
  
  customElements.define("dropdown-item", DropdownItem);
  